import React from 'react';
import styled from 'styled-components';
import { Field } from 'react-final-form';

import { Icon } from 'components/ui';
import { useTheme } from '@mui/material';

const FormRadioIconButton = ({ name, value, icon, label, type, ...props }) => {
  const theme = useTheme()
  return (
    <Field style={{ width: '100%' }} name={name}>
      {({ input, meta }) => {
        return (
          <Wrapper
            onClick={(e) => {
              input.onChange(value);
            }}
            checked={input.value === value}
          >
            <Icon
              icon={icon}
              type={type}
              style={{
                fontSize: 16,
                color: input.value === value ? theme.palette.colors.white : theme.palette.colors.gray300,
                transition: 'all .3s',
              }}
            />
            <Label style={{ margin: 0 }} checked={input.value === value}>
              {label}
            </Label>
          </Wrapper>
        );
      }}
    </Field>
  );
};

const Wrapper = styled.div`
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
  padding: 12px 32px;
  justify-content: center;
  gap: 10px;
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  background: ${({ checked, theme }) => (checked ? theme.palette.colors.blue100 : theme.palette.colors.gray100)};
  border: 1px solid
    ${({ checked, theme }) => (checked ? theme.palette.colors.blue100 : theme.palette.colors.gray300)};
  &:hover {
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  }
`;

const Label = styled.label`
  display: block;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: ${({ checked, theme }) => (checked ? theme.palette.colors.white : theme.palette.colors.gray300)};
  margin-top: 10px;
  transition: all 0.3s;
  text-align: center;
`;

export default FormRadioIconButton;
